import { jsPDF } from "jspdf";

// Notiline factura ante ARCA únicamente su comisión de servicio (ver
// functions/arca/), nunca el monto total de una compra: ese dinero va
// directo al vendedor/anfitrión vía PayPal. Por eso esto es un comprobante
// de la plataforma (constancia de la operación), no una factura fiscal.
const NOTILINE_BLUE = [3, 5, 83];
const GRAY_LINE = [200, 200, 200];
const GRAY_TEXT = [110, 110, 110];

const RECEIPT_LABELS = {
  auto: { title: "Comprobante de compra/reserva de auto", sellerLabel: "Vendedor" },
  viaje: { title: "Comprobante de reserva de viaje/propiedad", sellerLabel: "Anfitrión" },
  tienda: { title: "Comprobante de compra en tienda", sellerLabel: "Tienda" },
  evento: { title: "Comprobante de compra de entrada", sellerLabel: "Organizador" },
  oferta: { title: "Comprobante de compra de oferta", sellerLabel: "Vendedor" },
};

const DISCLAIMER =
  "Este comprobante certifica una operación realizada a través de la plataforma Notiline y no constituye una " +
  "factura fiscal (AFIP/ARCA): el pago fue realizado directamente al vendedor/anfitrión. Si necesitás una " +
  "factura para fines impositivos, solicitala directamente a la otra parte de la operación.";

/**
 * Genera y descarga un PDF con el comprobante de una compra/reserva de
 * Notiline (autos, viajes, tiendas o entradas de eventos).
 */
export function downloadPurchaseReceipt({
  type,
  id,
  itemTitle,
  amount,
  currency = "USD",
  status,
  date,
  buyerName,
  buyerEmail,
  sellerName,
}) {
  const labels = RECEIPT_LABELS[type] || { title: "Comprobante de compra", sellerLabel: "Vendedor" };
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 48;

  doc.setFillColor(...NOTILINE_BLUE);
  doc.rect(0, 0, pageWidth, 80, "F");
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.text("Notiline", margin, 48);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("www.notiline.com", margin, 64);

  let y = 112;
  doc.setTextColor(20, 20, 20);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text(labels.title, margin, y);
  y += 12;
  doc.setDrawColor(...GRAY_LINE);
  doc.line(margin, y, pageWidth - margin, y);
  y += 30;

  doc.setFontSize(11);
  const row = (labelText, value) => {
    if (!value) return;
    doc.setFont("helvetica", "bold");
    doc.text(`${labelText}:`, margin, y);
    doc.setFont("helvetica", "normal");
    const lines = doc.splitTextToSize(String(value), pageWidth - margin - (margin + 150));
    doc.text(lines, margin + 150, y);
    y += 22 * lines.length;
  };

  row("N° de comprobante", `NL-${id}`);
  row(
    "Fecha",
    date instanceof Date && !isNaN(date)
      ? date.toLocaleDateString("es-AR", { year: "numeric", month: "long", day: "numeric" })
      : ""
  );
  row("Concepto", itemTitle);
  row(labels.sellerLabel, sellerName);
  row("Comprador", buyerName);
  row("Email", buyerEmail);
  row("Estado", status);

  y += 8;
  doc.setDrawColor(...GRAY_LINE);
  doc.line(margin, y, pageWidth - margin, y);
  y += 32;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Monto total", margin, y);
  doc.text(`${currency} ${Number(amount || 0).toFixed(2)}`, pageWidth - margin, y, { align: "right" });
  y += 44;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(...GRAY_TEXT);
  doc.text(doc.splitTextToSize(DISCLAIMER, pageWidth - margin * 2), margin, y);

  doc.save(`comprobante-notiline-${type}-${id}.pdf`);
}
